import logo from "../svg/amp-logo.svg";
import { AppBar, IconButton, ThemeProvider, Toolbar, createTheme } from "@mui/material";
import { ArrowBackIosNew } from "@mui/icons-material";
import { useTranslation, Trans } from 'react-i18next';
import React, { FC, useState } from "react";

const headerTheme = createTheme({
    palette: {
      primary: {
        main: '#fff',
      },
    },
  });

interface HeaderProps {
    ampUrl?: string;
}
export const Header: FC<HeaderProps> = ({ampUrl}) => {

    const goToAmpPage = (): void => {
        if (ampUrl) {
            window.location.href = ampUrl;
        } else {
            window.location.href = 'https://amp.quebec/';
        }
      };
      const { t, i18n } = useTranslation();

    const [language, setLanguage] = useState(i18n.resolvedLanguage === 'en' ? 'fr' : 'en');
    const handleToggleLanguage = () => {
      i18n.changeLanguage(language);
      const newLanguage = language === 'en' ? 'fr' : 'en';
      setLanguage(newLanguage);
    };

    return (
      <>
        <ThemeProvider theme={headerTheme}>
          <AppBar position='sticky'>
            <Toolbar>
            <IconButton edge='start' color='inherit' aria-label='menu' onClick={(): void => goToAmpPage()}>
              <ArrowBackIosNew />
            </IconButton>
              <img src={logo} className='amp-logo' alt="Logo de l'AMP" onClick={(): void => goToAmpPage()} />
              <span className='spacer' />
              <div>
                <button onClick={handleToggleLanguage} style={{textTransform: 'uppercase'}}>{language}</button>
              </div>
            </Toolbar>
          </AppBar>
        </ThemeProvider>
      </>
    );
  };
